import { render, staticRenderFns } from "./ForumResponseBodyText.vue?vue&type=template&id=b5d5bb38&scoped=true"
import script from "./ForumResponseBodyText.vue?vue&type=script&lang=js"
export * from "./ForumResponseBodyText.vue?vue&type=script&lang=js"
import style0 from "./ForumResponseBodyText.vue?vue&type=style&index=0&id=b5d5bb38&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5d5bb38",
  null
  
)

export default component.exports